import { Component } from '@angular/core';
import { PrivacyInformationTestIds } from './sb-privacy-information.test-ids';

@Component({
  selector: 'app-sb-privacy-information',
  imports: [],
  templateUrl: './sb-privacy-information.component.html',
  styleUrl: './sb-privacy-information.component.scss'
})
export class SbPrivacyInformationComponent {
  protected readonly testIds = PrivacyInformationTestIds;
}
